import React, { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import { Bar } from '@ant-design/plots';
import "./scss/report.scss"
import { Table, Spin, Button } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../utils/storage.service";

const ReportHeadOffice = () => {
    const [title, setTitle] = useState("Head Office")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState([])
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }

    const fetchData = async (sD, eD, type) => {
        let payload = {
            startDate: sD,
            endDate: eD,
            type: type
        }

        const rs = await axiosService(`api/reports/head-office`, "POST", payload)
        const { data } = rs
        if (data.code === 200) {
            let { dataByStore } = data.data
            setTable(dataByStore ?? [])
            setLoading(false)
        }
    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, 1)
    }, [startDate, endDate])


    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = [
        {
            title: 'Cơ sở',
            dataIndex: 'store_name',
            render: (data) => {
                return (
                    <p>{data}</p>
                )
            },
            sorter: (a, b) => a.name.length - b.name.length,
        },
        {
            title: 'Tiền phải thu',
            dataIndex: 'netPrice',
            align: "center",
            render: (data) => {
                return (
                    <p className="text2">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.countServe - b.countServe,
                multiple: 3,
            },
        },
        {
            title: 'Doanh số thuần',
            dataIndex: 'netPriceNoTax',
            align: "center",
            render: (data) => {
                return (
                    <p className="text2">{convertCurrency(data)}</p>
                )
            }
        },
        {
            title: 'Tiền đã thu',
            dataIndex: 'revenuePaid',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.countServe - b.countServe,
                multiple: 3,
            },
        },
        {
            title: 'Thực thu bán hàng',
            dataIndex: 'revenuePaidNoTax',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            }
        }
    ];
    const handleExportData = async () => {
        setLoading(true)
        let payload = {
            startDate: startDate,
            endDate: endDate,
            type: 2
        }

        axiosService(`api/reports/head-office`, "POST", payload)
        .then((res) => {
            if (res.data.code == 200) {
                window.open(res.data.data.url, '_blank');
                setLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setLoading(false)
        });
    }
    return (
        <div className={`container-fluid report-page ${styles.background}`}>
            <FilterReport 
                startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate}
                title={title} type={"cent-office"}
                userAdmin={userAdmin}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <div className="pt-2">
                    <div>
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <div className="border-bottom w-100 mb-2">
                                <div className="d-flex justify-content-between mb-2">
                                    <div>
                                        <strong>Bảng dữ liệu chi tiết</strong>
                                    </div>
                                    <div>
                                        <Button size="middle" type="primary" onClick={handleExportData}>
                                            <i className="fa-solid fa-file-excel mr-2"></i>Export Data
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <Table 
                                columns={columns} 
                                dataSource={table}
                                pagination={{ pageSize: 10 }} 
                                scroll={{ x: 1300 }}
                                rowKey={"store_id"}
                                bordered
                            />
                        </div>
                    </div>
                </div>
            </Spin>
        </div>
    )
}
export default ReportHeadOffice